/**
 * SESSION STORE
 * Global state management for user sessions
 */

import { create } from 'zustand';

interface SessionState {
  sessionId: string;
  isInitialized: boolean;
  userPreferences: {
    theme: 'dark' | 'light';
    language: string;
    aiVerbosity: 'concise' | 'detailed';
  };
  initializeSession: () => Promise<void>;
  updatePreferences: (preferences: Partial<SessionState['userPreferences']>) => void;
}

export const useSessionStore = create<SessionState>((set, get) => ({
  sessionId: '',
  isInitialized: false,
  userPreferences: {
    theme: 'dark',
    language: 'javascript',
    aiVerbosity: 'detailed',
  },

  initializeSession: async () => {
    const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    set({
      sessionId,
      isInitialized: true,
    });
  },

  updatePreferences: (preferences) => {
    set(state => ({
      userPreferences: {
        ...state.userPreferences,
        ...preferences,
      },
    }));
  },
}));